import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import styles from './Navbar.module.css';
import logoIcon from '../../public/logo/Tangibellight.png';
import { useAuthContext } from '@/context/AuthContext';

const Navbar = ({ promoVisible = true }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [productsDropdownOpen, setProductsDropdownOpen] = useState(false);
  const [dropdownTimer, setDropdownTimer] = useState(null);
  const { user, loading } = useAuthContext();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) { // Trigger after scrolling 10px
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <nav className={`${styles.navbar} ${promoVisible ? styles.navbarWithPromo : ''}`}>
      {/* Pill Background Div */}
      <div
        className={`
          ${styles.pillBackground} 
          ${isScrolled ? styles.pillBackgroundActive : ''}
        `}
      />
      <div className={styles.navContainer}>
        <div className={styles.navLeft}>
          <Link href="/" className={styles.logo} style={{ display: 'flex', alignItems: 'center', gap: '12px', textDecoration: 'none' }}>
            <Image
              src={logoIcon}
              alt="Zenyai Logo"
              width={32}
              height={32}
              priority
              quality={100}
              style={{ objectFit: 'contain' }}
            />
            <span style={{
              fontFamily: "'Varela Round', sans-serif",
              color: 'white',
              fontSize: '22px',
              fontWeight: '700',
              letterSpacing: '1px',
              textTransform: 'uppercase'
            }}>
              Zenyai
            </span>
          </Link>
        </div>

        <div className={styles.navCenter}>
          <div
            className={styles.dropdown}
            onMouseEnter={() => {
              if (dropdownTimer) {
                clearTimeout(dropdownTimer);
                setDropdownTimer(null);
              }
              setProductsDropdownOpen(true);
            }}
            onMouseLeave={() => {
              const timer = setTimeout(() => {
                setProductsDropdownOpen(false);
              }, 300);
              setDropdownTimer(timer);
            }}
          >
            <span className={styles.navLink}>
              Features
            </span>
            {productsDropdownOpen && (
              <div className={styles.dropdownMenu}>
                <Link href="/logic" className={styles.dropdownItem}>
                  Logic Pro Plugin
                </Link>
                <Link href="/research" className={styles.dropdownItem}>
                  Research Playground
                </Link>
              </div>
            )}
          </div>
          <Link href="/documentation" className={styles.navLink}>
            Docs
          </Link>
          <Link href="/contact" className={styles.navLink}>
            Contact
          </Link>
          <Link href="/blogs" className={styles.navLink}>
            Blog
          </Link>
          <Link href="/pricing" className={styles.navLink}>
            Pricing
          </Link>
        </div>

        <div className={styles.navRight}>
          {loading ? (
            <span className={styles.navLinkLogin}></span>
          ) : user ? (
            <span className={styles.navLinkLogin} title={user.email}>
              <span className={styles.statusDot}></span>
              {user.email && user.email.length > 20
                ? `${user.email.substring(0, 20)}...`
                : user.email}
            </span>
          ) : (
            <Link href="/Chat" className={styles.navLinkLogin}>
              Log In
            </Link>
          )}
          <Link href="/dashboard" className={styles.navLinkCTA}>
            Start Now
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 